import { Directive, HostBinding, HostListener, Input } from '@angular/core';

import { TableComponent } from './table.component';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ls-sort]'
})
export class SortableColumnDirective {
  @Input('ls-sort')
  public sortField: string;
  public table: TableComponent;

  @HostBinding('class.c-table__sorter')
  public sorterClass = true;
  @HostBinding('class.c-table__sorter--asc')
  public isSortedAsc: boolean;
  @HostBinding('class.c-table__sorter--desc')
  public isSortedDesc: boolean;

  @HostListener('click')
  public onClick(): void {
    if (this.table) {
      this.table.sort({ sortField: this.sortField });
    }
  }

  public registerTable(table: TableComponent): void {
    this.table = table;
  }

  public updateCurrentSorting(sortField: string, direction: string): void {
    this.isSortedAsc = sortField === this.sortField && direction === 'ASC';
    this.isSortedDesc = sortField === this.sortField && direction === 'DESC';
  }
}
